/**
 * Configuration settings for the testimonial carousel.
 *
 * @type {Object}
 */

export const settings = {
  dots: true,
  autoplay: true,
  infinite: true,
  speed: 1500,
  slidesToShow: 2,
  slidesToScroll: 2,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

/**
 * Generates an array of blog data for testimonials.
 *
 * @param {Function} t - The translation function from i18n for text translation.
 * @returns {Array} An array of testimonial data objects.
 */

export const testimonialData = ({ t }) => {
  return [
    {
      text: 'XpressBees has been a key partner for PayTM Mall since inception. Its reach and service quality ensures that millions of our customers receive their orders on time, every time',
      userImage: '/images/carousal/testimonials/VijayShekharSharma.webp',
      userName: 'VIJAY SHEKHAR SHARMA',
      Designation: 'Founder & CEO, PayTM',
    },
    {
      text: 'We at bijnis are trying to revolutionize sourcing for B2B of India and from our start, we found Xpressbees to be very sound partner who has been building the b2b logistics infra in the most apt manner while understanding the ground reality and building solutions around it',
      userImage: '/images/carousal/testimonials/SachinChauhanBijnis.webp',
      userName: 'SACHIN CHAUHAN',
      Designation: 'bijnis - Taking Factories to the world',
    },
    {
      text: '“Our relationship with XpressBees has been great for the last 2 years. Very responsive to business needs, open to feedback, and great service.”',
      userImage: '/images/carousal/testimonials/ViditAatrey.webp',
      userName: 'VIDIT AATREY',
      Designation: 'Founder & CEO - Meesho',
    },
    {
      text: "XpressBees consistently delivers outstanding flexibility and responsiveness in meeting our logistics needs. Their unwavering reliability and efficiency have played a vital role in our company's growth. Thank you for being a trusted partner in our journey to success.",
      userImage: '/images/carousal/testimonials/Aditya-Sharma.webp',
      userName: 'ADITYA SHARMA',
      Designation: 'Founder & Director - The Souled Store',
    },
    {
      text: '“Netmeds.com has depended on Xpressbees since our inception. They are an important courier partner and help us satisfy millions of customers in thousands of PIN codes all across India.”',
      userImage: '/images/carousal/testimonials/pradeep.webp',
      userName: 'PRADEEP DADHA',
      Designation: 'Founder & CEO - Netmeds.com',
    },
    {
      text: '“We have been super happy and proud working with a partner like Xpressbees . I have faced challenges earlier with other logisitics companies where they don’t give priority to clients if their share of business is not high in their portfolio. Best part about XB is that they work with us and other clients with same rigour and passion irrespective of size of business. Their on time delivery percentage is exceptional, and follow up reports are helpful. I would certainly recommend XB Logistics to anyone looking for a quality 3PL.”',
      userImage: '/images/carousal/testimonials/amit.webp',
      userName: 'AMIT CHAUDHARY',
      Designation: 'Co-founder - Lenskart',
    },
  ];
};
